"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginLanguageSelector = void 0;
const react_1 = __importStar(require("react"));
const Combobox_1 = require("../../../../controls/Combobox");
const loginLanguageSelectorControlRenderer_1 = require("./renderers/loginLanguageSelectorControlRenderer");
const LoginLanguageSelector = (_a) => {
    var { value, disabled = false, items, onChange, iconGetter, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["value", "disabled", "items", "onChange", "iconGetter", 'data-selector-id']);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'login-language-selector', [initialDataSelectorId]);
    return (react_1.default.createElement(Combobox_1.Combobox, Object.assign({}, rest, { "data-selector-id": dataSelectorId, disabled: disabled, value: value, data: items, textGetter: ({ title }) => title, valueGetter: ({ value }) => value, onChange: onChange, controlRenderer: (0, loginLanguageSelectorControlRenderer_1.loginLanguageSelectorControlRenderer)({ iconGetter }) })));
};
exports.LoginLanguageSelector = LoginLanguageSelector;
//# sourceMappingURL=LoginLanguageSelector.js.map